import { NavLink } from 'react-router-dom';

type NavItem = {
  label: string;
  to: string;
  disabled?: boolean;
};

const navItems: NavItem[] = [
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Month Overview', to: '/months' },
  { label: 'Transactions', to: '/transactions' },
  { label: 'Pending Payments', to: '/pending-payments' },
  { label: 'Stake Snapshots', to: '/stake-snapshots' },
  { label: 'Audit Logs', to: '/audit-logs' },
  { label: 'Profile', to: '/profile' },
  { label: 'Change Password', to: '/change-password' },
];

export const Sidebar = () => {
  return (
    <aside className="sidebar">
      <div>
        <div className="badge" style={{ background: 'rgba(255,255,255,0.2)', color: '#fff' }}>
          HASH SOFTWARE
        </div>
        <h3 style={{ margin: '18px 0 4px', fontSize: '1.3rem', fontWeight: 600 }}>Revenue Tracker</h3>
        <p style={{ margin: 0, opacity: 0.72, fontSize: '0.9rem' }}>Finance cockpit for founders</p>
      </div>

      <nav>
        {navItems.map((item) =>
          item.disabled ? (
            <span key={item.label} className="subtle-text" style={{ opacity: 0.45, cursor: 'not-allowed' }}>
              {item.label}
            </span>
          ) : (
            <NavLink key={item.label} to={item.to} className={({ isActive }) => (isActive ? 'active' : '')}>
              {item.label}
            </NavLink>
          ),
        )}
      </nav>
    </aside>
  );
};

